import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {

  public isMobile: boolean = false;
  public hideMain: boolean = false;
  constructor(private router: Router ) { }

  ngOnInit() {
    
    if(this.router.url.toString().includes("/Register/Main/TermsRepository/")){
      this.hideMain = true
    }
  }

}
